<template>
    <div>
        <div class="p-6 bg-white border-b border-gray-200">
            Content
        </div>
    </div>
</template>

<script>
    import JetApplicationLogo from '@/Jetstream/ApplicationLogo'

    export default {
        components: {
            JetApplicationLogo,
        },
    }
</script>
